<app-faq-chatbot></app-faq-chatbot>
<router-outlet></router-outlet>

